//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import abstract from '@/assets/imgs/abstract.svg';

export default {
  name: 'KnockContact',

  data() {
    return {
      abstract
    };
  },

  computed: {
    bannerSectionBg() {
      return `background: #131212 url("${abstract}") no-repeat scroll top right`;
    }
  }
};
